var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BButton',_vm._b({attrs:{"disabled":_vm.disabled,"variant":_vm.type,"size":"sm"},on:{"click":_vm.addNew}},'BButton',_vm.$attrs,false),[_c('plus-box-icon'),_vm._v("\n    Add "+_vm._s(_vm.itemName)+"\n")],1)}
var staticRenderFns = []

export { render, staticRenderFns }